<template>
  <div class="xz_detail_resume">
    <transition name="loadShadow">
      <div class="loadShadow" v-show="saveResumeing">
        <i class="loadBlock"></i>
      </div>
    </transition>
    <div class="xz_detail_center">
      <div class="xz_detail_part">
        <p class="xz_detail_part_title">沟通备注</p>
        <div class="noteCon">
          <label class="note_inputLabel">备注：</label>
          <textarea v-model="personalTag" class="noteArea" @input="wordsConunt"></textarea>
          <span class="confineWords"> {{words}} / {{maxWords}}</span>
          <div class="noteExample">
            <button @click="saveNote" class="xz_add_history" type="button">保存</button>
            <div>
              <p>1、和用户沟通情况不是很好</p>
              <p>2、用户未接电话</p>
            </div>
          </div>
        </div>
      </div>
      <div class="xz_detail_part">
        <p class="xz_detail_part_title">基本信息</p>
        <div class="xz_double_part">
          <div class="customField textInput">
            <p class="customField_title">用户姓名：</p>
            <div class="inputCommon">
              <input type="text" class="inputStyle" v-model="psnBaseInfo.psnName" disabled>
            </div>
          </div>
          <div class="customField textInput">
            <p class="customField_title">性别：</p>
            <div class="inputCommon">
              <input type="text" class="inputStyle" v-model="psnBaseInfo.psnSex" disabled>
            </div>
          </div>
        </div>
        <div class="xz_double_part">
          <div class="customField textInput">
            <p class="customField_title">出生日期：</p>
            <div class="inputCommon">
              <input type="text" class="inputStyle" v-model="psnPersonInfo.psnBirth" disabled>
            </div>
          </div>
          <div class="customField textInput">
            <p class="customField_title">最高学历：</p>
            <div class="inputCommon">
              <input type="text" class="inputStyle" v-model="psnBaseInfo.psnEduLvl" disabled>
            </div>
          </div>
        </div>
        <div class="xz_double_part">
          <div class="customField textInput">
            <p class="customField_title">期望城市：</p>
            <div class="inputCommon">
              <input type="text" class="inputStyle" v-model="intentNation" disabled>
            </div>
          </div>
          <div class="customField textInput">
            <p class="customField_title">所在地：</p>
            <div class="inputCommon">
              <input type="text" class="inputStyle" v-model="currentNation" disabled>
            </div>
          </div>
        </div>
      </div>
    <div class="xz_detail_center">
      <div class="xz_detail_part">
        <p class="xz_detail_part_title">部队经历</p>
        <div class="xz_double_part">
          <div class="customField textInput">
            <p class="customField_title">身份：</p>
            <div class="inputCommon">
              <input type="text" class="inputStyle" v-model="psnPersonInfo.strArmyIdent" disabled>
            </div>
          </div>
          <div class="customField textInput">
            <p class="customField_title">军龄：</p>
            <div class="inputCommon">
              <input type="text" class="inputStyle" v-model="psnPersonInfo.strArmyAge" disabled>
            </div>
          </div>
        </div>
        <div class="xz_double_part">
          <div class="customField textInput">
            <p class="customField_title">专业：</p>
            <div class="inputCommon">
              <input type="text" class="inputStyle" v-model="psnPersonInfo.strArmyMajor" disabled>
            </div>
          </div>
          <div class="customField textInput">
            <p class="customField_title">职位：</p>
            <div class="inputCommon">
              <input type="text" class="inputStyle" v-model="psnPersonInfo.strArmyTitle" disabled>
            </div>
          </div>
        </div>
        <div class="xz_double_part">
          <div class="customField textInput">
            <p class="customField_title">军种：</p>
            <div class="inputCommon">
              <input type="text" class="inputStyle" v-model="psnPersonInfo.strArmyType" disabled>
            </div>
          </div>
          <div class="customField textInput">
            <p class="customField_title">党员：</p>
            <div class="inputCommon">
              <input type="text" class="inputStyle" v-model="psnPersonInfo.strCpcMember" disabled>
            </div>
          </div>
        </div>
        <div class="xz_double_part">
          <div class="customField textInput">
            <p class="customField_title">立功授奖：</p>
            <div class="inputCommon" style="width: 610px;">
              <input type="text" class="inputStyle" v-model="psnPersonInfo.strArmyCredit" disabled>
            </div>
          </div>
        </div>
      </div>
      

      <div class="xz_detail_part">
        <p class="xz_detail_part_title">工作经历</p>
        <div class="wx_history" v-if="wx_historyList.length > 0">
          <ul class="wx_history_list">
            <li class="wx_list_item" v-for="(item, index) in wx_historyList" :key="index">
              <div class="historyHeader">
                <div class="wx_history_content">
                  <span>{{item.psnCompany}}</span>
                </div>
                <div style="display:flex;">
                  <div class="wx_date">
                    <span>{{item.psnWorkStartTime}} - {{item.psnWorkEndTime}}</span>
                  </div>
                </div>
              </div>
              <div class="historyMain">
                <div class="wx_history_job">
                  <span>{{item.psnJob}}/{{item.psnJobPart}}</span>
                </div>
              </div>
              <div class="historyMain">
                <div class="wx_history_des">
                  <span>{{item.psnJobDes}}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
      <div class="xz_detail_part">
        <p class="xz_detail_part_title">教育经历</p>
        <div class="wx_history" v-if="wx_educationList.length > 0">
          <ul class="wx_history_list">
            <li class="wx_list_item" v-for="(item, index) in wx_educationList" :key="index">
              <div class="historyHeader">
                <div class="wx_history_content">
                  <span>{{item.psnSchool}}</span>
                </div>
                <div style="display:flex;">
                  <div class="wx_date">
                    <span>{{item.psnEduStartTime}} - {{item.psnGradTime}}</span>
                  </div>
                </div>
              </div>
              <div class="historyMain">
                <div class="wx_history_job">
                  <span>{{item.psnMajor}}/{{item.psnDegree}}</span>
                </div>
              </div>
              <div class="historyMain">
                <div class="wx_history_des">
                  <span>{{item.psnOtherInf}}</span>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
  import IdentifyInput from "../form/textInput";
  import JobFun from "../../plugins/JOBFUN";
  import xz from "../../common";
  //职能数据
  import funData from '../../store/funData';
  export default {
    components: {
      IdentifyInput,
      JobFun
    },
    props: {
      "resume": {
        type: Object,
        default: function () {
          return {};
        }
      },
      "qwq": {
        type: Object,
        default: function () {
          return {};
        }
      },
      "psnPersonInfo": {
        type: Object,
        default: function () {
          return {};
        }
      },
      "baseResume": {
        type: Object,
        default: function () {
          return {};
        }
      }
    },
    data() {
      return {
         //
        funData: funData, //职能数据
        psnid: "", //个人id
        //保存简历加载
        saveResumeing: false,
        jobfunVisible: false,
        gender: "",
        birthDate: "",
        diploma: "",
        workYears: "",
        bornNation: "",
      
        currentSalary: {
          value: "",
          identifyType: ""
        },
        currentCompany: {
          value: "",
          identifyType: ""
        },
        currentJob: {
          value: "",
          identifyType: ""
        },
        intentWork: {
          value: "",
          identifyType: ""
        },
        intentSalary: {
          value: "",
          identifyType: ""
        },
        history_school: {
          value: "",
          identifyType: ""
        },
        history_profession: {
          value: "",
          identifyType: ""
        },
        history_job: {
          value: "",
          identifyType: ""
        },
        history_company: {
          value: "",
          identifyType: ""
        },
        professionArr: [],
        profession: {
          value: "",
          identifyType: ""
        },
        personalTag: "",
        psnName: {
          value: "",
          identifyType: ""
        },
        //基本信息
        base: null,
        //基本信息
        psnBaseInfo: {
          psnName: '',
          psnNowJob: '',
          psnNowCompany: '',
          psnSex: '',
          psnAdd: '',
          psnCurrDate: '',
          psnNation: '', //籍贯
          psnEduLvl: "",
          psnWorkExp: "",
          psnAge: "",
          psnFromInfo: ""
        },
        // 个人资料
        psnPersonInfo: {
          psnBirth: '',
          psnIndustry: '',
          psnLang: '',
          psnMarriage: '',
          psnPerNation: '',
          psnStartWork: '',
          psnWorkState: '',
          psnCurrSalary: "",
          strArmyAge: "",
          // 身份
          strArmyIdent: "",
          // 专业
          strArmyMajor: "",
          // 军种
          strArmyType: "",
          // 是否是党员
          strCpcMember: "",
          // 职务
          strArmyTitle: "",
          // 立功授奖
          strArmyCredit: ""
        },
        //求职意向
        psnJobIntentInfo: {
          psnIntentAdd: '',
          psnIntentInd: '',
          psnIntentJob: '',
          psnIntentJobType: '',
          psnIntentNation: '',
          psnIntentPay: '',
          psnStrFuncNames: '',
        },
        currentStatus: "",
        marriage: "",
        currentSelected: "",
        intentSelected: "",
        workStartTime: "",
        workEndTime: "",
        educationStartTime: "",
        educationEndTime: "",
        startWorkYear: "",
        //工作经历
        wx_historyList: [],
        // 教育经历
        wx_educationList:[],
        //职能
        jobFun: "",
        hasResult: false, //判断是否有结果
        searchResult: [], //关键字结果集,
        //字数限制
        words: 0,
        maxWords: 50,
        // 期望地点
        intentNation: "",
        // 所在地
        currentNation: ""
      }
    },
    mounted(){
      this.clearAll();
    },
    watch: {
      "qwq": {
        handler: function () {
          // console.log('qwq',this.qwq.psnSkillTag)
          this.personalTag = this.qwq.psnSkillTag
        },
        immediate: true
      },
      "psnPersonInfo": {
        handler: function () {
          // console.log('qwq',this.psnPersonInfo)
          // this.psnPersonInfo = this.psnPersonInfo
        },
        immediate: true
      },
      "resume": {
        handler: function () {
          // console.log('resume',this.resume)
          if (this.resume) this.psnid = this.resume.orderid;
        },
        immediate: true
      },
      "baseResume": {
        handler: function () {
          this.clearAll(); //清理数据
          if (this.baseResume) {
            console.log('a',this.baseResume);
            const resume = this.baseResume;
            if(resume.psnBaseInfo){
              this.psnBaseInfo = {
                psnName: resume.psnBaseInfo.psnName,
                psnNowJob: resume.psnBaseInfo.psnNowJob,
                psnNowCompany: resume.psnBaseInfo.psnNowCompany,
                psnSex: resume.psnBaseInfo.psnSex,
                psnAdd: resume.psnBaseInfo.psnAdd,
                psnCurrDate: resume.psnBaseInfo.psnCurrDate,
                psnNation: resume.psnBaseInfo.psnNation, //籍贯
                psnEduLvl: resume.psnBaseInfo.psnEduLvl,
                psnWorkExp: resume.psnBaseInfo.psnWorkExp
              }
              //currentNation
              if(resume.psnBaseInfo.psnNation){
                xz.codeToInfor(resume.psnBaseInfo.psnNation).then(res => {
                  if(res){
                    let region = [];
                    if(res.Province){
                      region.push(res.Province);
                    }
                    if(res.City){
                      region.push(res.City);
                    }
                    if(res.Area){
                      region.push(res.Area);
                    }
                    this.currentNation = region.join("-");
                  }
                })
              }
            }
            //
            if(resume.psnJobIntentInfo){
              this.psnJobIntentInfo = {
                psnIntentAdd: resume.psnJobIntentInfo.psnIntentAdd,
                psnIntentInd: resume.psnJobIntentInfo.psnIntentInd,
                psnIntentJob: resume.psnJobIntentInfo.psnIntentJob,
                psnIntentJobType: resume.psnJobIntentInfo.psnIntentJobType,
                psnIntentNation: resume.psnJobIntentInfo.psnIntentNation,
                psnIntentPay: resume.psnJobIntentInfo.psnIntentPay,
                psnStrFuncNames: resume.psnJobIntentInfo.psnStrFuncNames,
              }
              if(resume.psnJobIntentInfo.psnIntentNation){
                xz.codeToInfor(resume.psnJobIntentInfo.psnIntentNation).then(res => {
                  if(res){
                    let region = [];
                    if(res.Province){
                      region.push(res.Province);
                    }
                    if(res.City){
                      region.push(res.City);
                    }
                    if(res.Area){
                      region.push(res.Area);
                    }
                    this.intentNation = region.join("-");
                  }
                })
              }
            }
            //
            if(resume.psnPersonInfo){
              let birthYear = "";
              if(resume.psnPersonInfo.psnBirth){
                birthYear = new Date(resume.psnPersonInfo.psnBirth).getFullYear();
              }
              this.psnPersonInfo = {
                psnBirth: birthYear ? birthYear + "年" : "",
                psnIndustry: resume.psnPersonInfo.psnIndustry,
                psnLang: resume.psnPersonInfo.psnLang,
                psnMarriage: resume.psnPersonInfo.psnMarriage,
                psnPerNation: resume.psnPersonInfo.psnPerNation,
                psnStartWork: resume.psnPersonInfo.psnStartWork,
                psnWorkState: resume.psnPersonInfo.psnWorkState,
                psnCurrSalary: resume.psnPersonInfo.psnCurrSalary,
                // 军龄
                strArmyAge: resume.psnPersonInfo.strArmyAge,
                // 身份
                strArmyIdent: resume.psnPersonInfo.strArmyIdent,
                // 专业
                strArmyMajor: resume.psnPersonInfo.strArmyMajor,
                // 军种
                strArmyType: resume.psnPersonInfo.strArmyType,
                // 是否是党员
                strCpcMember: resume.psnPersonInfo.strCpcMember === 'y' ? '是' : '否',
                // 职务
                strArmyTitle: resume.psnPersonInfo.strArmyTitle,
                // 立功授奖
                strArmyCredit: resume.psnPersonInfo.strArmyCredit
              }
            }
            // 工作经历
            if(resume.psnWorkInfo){
              let arr = [];
              if(resume.psnWorkInfo.length){
                let list = resume.psnWorkInfo;
                list.forEach(l => {
                  let startTime = new Date(l.psnWorkStartTime);
                  let endTime = new Date(l.psnWorkEndTime);
                  l.psnWorkStartTime = startTime.getFullYear() + "-" +(startTime.getMonth() + 1);
                  l.psnWorkEndTime = l.ifNow == "1" ? "至今" : endTime.getFullYear() + "-" + (endTime.getMonth() + 1)
                  arr.push(l);
                })
              }
              this.wx_historyList = arr;
            }
            // 教育经历
            if(resume.psnEduInfo){
              let arr = [];
              if(resume.psnEduInfo.length){
                let list = resume.psnEduInfo;
                list.forEach(l => {
                  let startTime = new Date(l.psnEduStartTime);
                  let endTime = new Date(l.psnGradTime);
                  l.psnEduStartTime = startTime.getFullYear() + "-" +(startTime.getMonth() + 1);
                  // l.psnGradTime = l.ifNow == "1" ? "至今" : endTime.getFullYear() + "-" + (endTime.getMonth() + 1)
                  l.psnGradTime = endTime.getFullYear() + "-" + (endTime.getMonth() + 1)
                  arr.push(l);
                })
              }
              this.wx_educationList = arr;
            }
            
          }
        },
        immediate: true
      }
    },
    methods: {
      returnPsnName(v){
        this.$set(this.psnName, "value", v);
      },
      returnSalary(v) {
        this.$set(this.currentSalary, "value", v);
      },
      returnCompany(v) {
        this.$set(this.currentCompany, "value", v);
      },
      returnJob(v) {
        this.$set(this.currentJob, "value", v);
      },
      returnIntentWork(v) {
        this.$set(this.intentWork, "value", v);
      },
      returnIntentSalary(v) {
        this.$set(this.intentSalary, "value", v);
      },
      returnProfession(v) {
        this.$set(this.profession, "value", v);
      },
      returnHistory_job(v) {
        this.$set(this.history_job, "value", v);
      },
      returnHistory_company(v) {
        this.$set(this.history_company, "value", v);
      },
      returnHistory_school(v) {
        this.$set(this.history_school, "value", v);
      },
      returnHistory_profession(v) {
        this.$set(this.history_profession, "value", v);
      },
      //现居住地
      currentRegion(region) {
        if (region.area) {
          this.currentSelected = region.area.code;
        } else if (region.city) {
          this.currentSelected = region.city.code;
        } else {
          this.currentSelected = region.province.code;
        }
      },
      //期望地点
      intentRegion(region) {
        if (region.area) {
          this.intentSelected = region.area.code;
        } else if (region.city) {
          this.intentSelected = region.city.code;
        } else {
          this.intentSelected = region.province.code;
        }
      },
      //籍贯
      getBornNation(region){
        if (region.area) {
          this.bornNation = region.area.code;
        } else if (region.city) {
          this.bornNation = region.city.code;
        } else {
          this.bornNation = region.province.code;
        }
      },
      //编辑工作经历
      history_edit() {},
      //编辑工作经历
      workHistory_edit(i) {
        this.$set(this.history_company, "value", this.wx_historyList[i].psnCompany);
        this.$set(this.history_job, "value", this.wx_historyList[i].psnJob);
        this.workStartTime = this.wx_historyList[i].psnWorkStartTime;
        this.workEndTime = this.wx_historyList[i].psnWorkEndTime;
        this.workHistoryId = this.wx_historyList[i].workinfoid;
      }, 
      //删除工作经历
      workHistory_delete(i){
        xz.initBaseResume(Cookies.get("userid-b"), this.psnBaseInfo, this.psnid).then(id => {
          if (id) {
            let workId = this.wx_historyList[i].workinfoid;
            xz.deleteWorkHistory("psnworkinfoinner", id, workId).then(res => {
              if(res){
                //保存成功重新获取教育经历
                xz.userInfo(this.psnid).then( res => {
                  if(res){
                    let inner = res.innerinfo;
                    this.wx_historyList = inner.psnWorkInfo;
                  }
                })
                this.clearWorkHistory();
              }
            })
          }
        })
      },
      //编辑教育经历
      educationHistory_edit(i){
        this.$set(this.history_school, "value", this.wx_educationList[i].psnSchool);
        this.$set(this.history_profession, "value", this.wx_educationList[i].psnMajor);
        this.educationStartTime = this.wx_educationList[i].psnEduStartTime;
        this.educationEndTime = this.wx_educationList[i].psnGradTime;
        this.educationId = this.wx_educationList[i].eduinfoid;
      },
      //删除教育经历
      educationHistory_delete(i){
        xz.initBaseResume(Cookies.get("userid-b"), this.psnBaseInfo, this.psnid).then(id => {
          if (id) {
            let eduid = this.wx_educationList[i].eduinfoid;
            xz.deleteEduHistory("psneduinfoinner", id, eduid).then(res => {
              if(res){
                //保存成功重新获取教育经历
                xz.userInfo(this.psnid).then( res => {
                  if(res){
                    let inner = res.innerinfo;
                    this.wx_educationList = inner.psnEduInfo;
                  }
                })
                this.clearEducationHistory();
              }
            })
          }
        })
      },
      //输入计数
      wordsConunt(){
        let len = this.personalTag.length;
        if(len > 50){
          this.words = 50;
          this.personalTag = this.personalTag.slice(0, 50);
        }else{
          this.words = len;
        }
      },
      //保存简历
      addResume() {
        if(!this.psnName.value.trim()) return;
        this.saveResumeing = true;
        //初始化个人资料
        xz.initBaseResume(Cookies.get("userid-b"), this.psnBaseInfo, this.psnid).then(id => {
          if (id) {
            this.$set(this.psnBaseInfo, "psnName", this.psnName.value);
            this.$set(this.psnBaseInfo, "psnSex", this.gender);
            this.$set(this.psnBaseInfo, "psnEduLvl", this.diploma);
            this.$set(this.psnBaseInfo, "psnWorkExp", this.workYears);
            if(this.bornNation) this.$set(this.psnBaseInfo, "psnNation", this.bornNation);
            if(this.currentJob.value) this.$set(this.psnBaseInfo, "psnNowJob", this.currentJob.value);
            if(this.currentCompany.value) this.$set(this.psnBaseInfo, "psnNowCompany", this.currentCompany.value);
            this.$set(this.psnPersonInfo, "psnWorkState", this.currentStatus);
            this.$set(this.psnPersonInfo, "psnStartWork", this.startWorkYear ? new Date(this.startWorkYear).getFullYear() : "");
            this.$set(this.psnPersonInfo, "psnPerNation", this.currentSelected);
            this.$set(this.psnPersonInfo, "psnMarriage", this.marriage);
            this.$set(this.psnPersonInfo, "psnBirth", this.$store.getters.formatDate(this.birthDate, "-"));
            this.$set(this.psnPersonInfo, "psnCurrSalary", this.currentSalary.value);
            let intentObj = {
              psnIntentPay: this.intentSalary.value,
              psnIntentJob: this.intentWork.value,
              psnIntentNation: this.intentSelected,
              psnIntentAdd: "",
              psnIntentInd: "",
              psnIntentJobType: "",
              psnStrFuncNames: this.jobFun ? this.jobFun : ''
            }
            //保存基本资料
            let baseResume = xz.saveBaseResume(id, this.psnBaseInfo);
            //保存个人资料
            let person = xz.saveResumeInformation(id, "psnpersoninfoinner", this.psnPersonInfo);
            //求职意向
            let intent = xz.saveResumeInformation(id, "psnjobintentinfoinner", intentObj);
            //保存专业技能
            let knowTags = xz.savePersonalTags(id, "knowtaginner", this.professionArr.join(), "knowtag");
            
            Promise.all([baseResume, person, intent, knowTags]).then( res => {
              this.saveResumeing = false;
              this.$message({
                message: '保存成功!',
                type: 'success'
              });
              res.forEach( r => {
                if(!r) alert("数据保存出错，请稍后再试");
              })
            }).catch(err => {
              console.log(err);
              alert("保存出错,请稍后再试");
              this.saveResumeing = false;
            })
          }
        })
      },
      //专业技能暂存
      pushProfession(){
        if(!this.profession.value.trim()) return;
        this.professionArr.push(this.profession.value);
        this.$set(this.profession, "value", "");
      },
      //教育经历
      saveEducation() {
        xz.initBaseResume(Cookies.get("userid-b"), this.psnBaseInfo, this.psnid).then(id => {
          if (id) {
            let educationData = {
              eduinfoid: this.educationId ? this.educationId : new Date().valueOf(),
              psnSchool: this.history_school.value,
              psnMajor: this.history_profession.value,
              psnDegree: "",
              psnEduStartTime: this.$store.getters.formatMonth(this.educationStartTime, "-"),
              psnGradTime: this.$store.getters.formatMonth(this.educationEndTime, "-")
            }
            xz.saveResumeInformation(id, "psneduinfoinner", educationData).then(res => {
              if(res){
                //保存成功重新获取教育经历
                xz.userInfo(this.psnid).then( res => {
                  if(res){
                    let inner = res.innerinfo;
                    this.wx_educationList = inner.psnEduInfo;
                    // console.log(this.wx_educationList)
                  }
                })
                this.clearEducationHistory();
              }
            })
          }
        })
      },
      //工作历史
      saveWorkExperience(){
        xz.initBaseResume(Cookies.get("userid-b"), this.psnBaseInfo, this.psnid).then(id => {
          if (id) {
            let workData = {
              workinfoid: this.workHistoryId ? this.workHistoryId : new Date().valueOf(),
              psnCompany: this.history_company.value,
              psnJob: this.history_job.value,
              psnWorkStartTime: this.$store.getters.formatMonth(this.workStartTime, "-"),
              psnWorkEndTime: this.$store.getters.formatMonth(this.workEndTime, "-"),
              psnJobLoc: "",
              psnJobNation: "",
              psnPay: "",
              psnJobDes: "",
              psnJobPart: "",
              psnStrLeavlingReson: "",
              psnStrFuncName: ""
            }
            xz.saveResumeInformation(id, "psnworkinfoinner", workData).then(res => {
              if(res){
                //保存成功重新获取工作历史
                xz.userInfo(this.psnid).then( res => {
                  if(res){
                    let inner = res.innerinfo;
                    this.wx_historyList = inner.psnWorkInfo;
                  }
                })
                this.clearWorkHistory();
              }
            })
          }
        })
      },
      //保存备注
      saveNote(){
        xz.initBaseResume(Cookies.get("userid-b"), this.psnBaseInfo, this.psnid).then(id => {
          if (id) {
            //个人备注
            xz.savePersonalTags(id, "skilltaginner", this.personalTag, "skilltag").then( res => {
              this.$message({
                message: res ? "保存备注成功" : "保存备注失败，稍后再试",
                type: res ? "success" : "error"
              });
            });
          }
        })
      },
      //删除标签
      deleteProfession(index){
        let tags = [];
        this.professionArr.forEach( (r, i) =>{
          if(i != index) tags.push(r);
        })
        this.professionArr = tags;
      },
      //清除工作历史表单内容
      clearWorkHistory(){
        this.$set(this.history_company, "value", "");
        this.$set(this.history_job, "value", "");
        this.workStartTime = "";
        this.workEndTime = "";
        this.workHistoryId = "";
      },
      //清除教育经历表单历史
      clearEducationHistory(){
        this.$set(this.history_school, "value", "");
        this.$set(this.history_profession, "value", "");
        this.educationStartTime = "";
        this.educationEndTime = "";
        this.educationId = "";
      },
      //返回选择的职能
      returnFun(data) {
        this.jobFun = data;
        this.jobfunVisible = false;
      },
      //选择结果
      chooseResult(e) {
        this.jobFun = e.target.innerText;
        this.hasResult = false;
      },
      //根据输入显示查找结果
      searchKeyWord() {
        this.searchResult = []; //重置
        if (this.jobFun.trim() != '') {
          for (let i = 0; i < this.funData.length; i++) { //第一级
            let hasKey = false; //判断有没有值

            let level1 = this.funData[i].type; //第一级名称
            let level2 = [];
            let level3 = [];
            if (level1.indexOf(this.jobFun) > -1) {
              hasKey = true;
            }
            for (let i2 = 0; i2 < this.funData[i].department.length; i2++) {
              let department = this.funData[i].department[i2];
              let level2Name = department.name ? department.name : ''; //第二级名字
              if (level2Name.indexOf(this.jobFun) > -1) {
                level2.push(level2Name);
                hasKey = true;
              }
              for (let i3 = 0; i3 < department.manager.length; i3++) {
                let manager = department.manager[i3];
                let level3Name = manager.name ? manager.name : ''; //第三级名字
                if (level3Name.indexOf(this.jobFun) > -1) {
                  level3.push(level3Name);
                  hasKey = true;
                }
              }
            }
            if (hasKey == true) { //如果4级中其中有关键词的话
              this.searchResult.push({
                level1: level1,
                level2: level2,
                level3: level3,
              })
              this.hasResult = true;
            }
          }
        } else {
          this.hasResult = false;
          this.searchResult = [];
        }
      },
      //检查职能分类
      checkentjobfun() {
        if (this.jobFun.trim()) {
          if (this.$refs.jobFunInput.classList.contains('error_alert')) {
            this.$refs.jobFunInput.classList.remove('error_alert');
          }
        }
      },
      //清空所有数据
      clearAll(){
        this.intentNation = "";
        this.currentNation = "";
        this.clearEducationHistory();
        this.clearWorkHistory();
        this.professionArr = [];
        this.wx_educationList = [];
        this.wx_historyList = [];
        this.$set(this.psnName, "value", "");
        this.$set(this.currentJob, "value", "");
        this.$set(this.currentCompany, "value", "");
        this.$set(this.currentSalary, "value", "");
        this.$set(this.intentWork, "value", "");
        this.$set(this.intentSalary, "value", "");
        this.gender = "";
        this.birthDate = "";
        this.diploma = "";
        this.workYears = "";
        this.bornNation = "";
        this.currentStatus = "";
        this.currentSelected = "";
        this.marriage = "";
        this.startWorkYear = "";
        this.intentSelected = "";
        // this.personalTag = "";
        this.words = 0;
      }
    }
  }
</script>
<style scoped>
  .xz_detail_part_title {
    font-size: 18px;
    font-weight: bold;
    color: #333;
    margin-bottom: 20px;
  }

  .xz_detail_resume {
    width: 100%;
    /* position: relative; */
  }

  .xz_detail_center {
    width: 760px;
    padding-top: 20px;
    margin: 0 auto;
  }

  .xz_double_part {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 20px;
  }

  .xz_add_cancel, .xz_add_history {
    font-size: 14px;
    display: block;
    padding: 8px 20px;
    color: #fff;
    border-radius: 5px;
    outline: none;
    cursor: pointer;
    background: #409eff;
    border: none;
  }
  .xz_add_cancel{
    background: #ed6b75 !important;
    margin-left: 30px !important;
  }

  .customField {
    display: flex;
  }

  .customField_title {
    display: block;
    width: 150px;
    height: 45px;
    line-height: 45px;
    text-align: right;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0;
    padding: 0 10px 0 0;
    color: #333;
    font-weight: bold;
    font-size: 14px;
  }

  .flexCenterContainer{
    display:flex;align-items:center;flex-wrap:wrap;
  }
  .tagsShow{
    width: 100%;
    display: block;
    margin-bottom: 15px;
    box-sizing: border-box;
    padding-left: 70px;
  }
  .tagsShowItem{
    margin-right: 15px;
    padding: 8px 25px 8px 18px;
    border-radius: 3px;
    background: #409eff;
    color: #fff;
    font-size: 13px;
    position: relative;
  }
  .closeTag{
    position: absolute;
    right: 2px;
    top: 3px;
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
  .xz_add_btn{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-top: 15px;
  }
  .jobFunInput{
    width: 100%;
    border: 1px solid #ddd;
    border-radius: 6px;
    height: 45px;
    font-size: 14px;
    padding: 0 15px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: none;
  }
  .noteArea{
    width: 500px;
    border: 1px solid #ddd;
    border-radius: 6px;
    height: 80px;
    font-size: 14px;
    padding: 0 15px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: none;
    padding: 10px;
  }
  .noteExample{
    width: 500px;
    box-sizing: border-box;
    margin-left: 150px;
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
  }
  .note_inputLabel{
    display: block;
    width: 150px;
    height: 45px;
    line-height: 45px;
    text-align: right;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    margin: 0;
    padding: 0 10px 0 0;
    color: #333;
    font-size: 14px;
    font-weight: 700;
  }
  .noteCon{
    display: flex;
    flex-wrap: wrap;
  }
  .confineWords{
    position: relative;
    top: 60px;
    left: 10px;
  }
</style>
<style>
  .customField .el-input__inner {
    width: 200px;
    border: 1px solid #ddd;
    height: 45px;
  }

  .customField .xz_con {
    width: 200px !important;
  }

  .customField .el-date-editor.el-input,
  .customField .el-date-editor.el-input__inner {
    width: 200px;
  }
  .textInput .inputStyle {
    width: 100%;
    border: 1px solid #ddd;
    height: 45px;
    font-size: 14px;
    padding: 0 15px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: none;
  }
  .xz_detail_resume .textInput .inputStyle{
    border: none;
    border-bottom: 1px solid #ddd;
    border-radius: 0;
  }
  .inputCommon{
    width: 200px;
  }
</style>